@if (hasAccess) {
  <div class="header">
    <div class="header__col-left md-hidden">
      <div class="header__actions">
        <p-button
          [label]="'header.support' | translate"
          (click)="onSupportClick()"
          icon="pi pi-question-circle"
          variant="text"
          styleClass="pssr-icon-button" />

        <p-button
          [label]="'header.userGuide' | translate"
          (click)="onUserGuideClick()"
          icon="pi pi-book"
          variant="text"
          styleClass="pssr-icon-button" />
      </div>
    </div>

    <div class="header__col-center">
      <div class="header__branding">
        <div class="header__branding-logo">
          <img
            src="/images/CVX-Logo.png"
            alt="CVX Logo"
            class="header__logo-img" />
        </div>
        <div class="header__branding-project">
          <a
            class="pssr-link"
            href="/">
            {{ 'app.title' | translate }}
          </a>
        </div>
      </div>
    </div>

    <div class="header__col-right md-hidden">
      <div class="header__user">
        <img
          src="/images/no-avatar.png"
          alt="User Avatar"
          class="header__user-avatar" />
        <span class="header__user-name">{{ fullName }}</span>
      </div>
    </div>
  </div>
}
